


















import { Component, Vue } from "vue-property-decorator";
import { ResultInfo } from "@/types/result";
@Component
export default class Success extends Vue {
  directionType = {
      horizontal: "horizontal",
      vertical: "vertical",
  };

  get result(): ResultInfo {
      return {
          title: "result.success.title",
          description: "result.success.description",
      };
  }
}
